import React from 'react';

const Header = () => {
  return (
    <header className="sticky top-0 z-40 bg-white border-b border-secondary-200 shadow-sm">
      <div className="px-6 py-4 flex items-center">
        {/* 로고 */}
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-gradient-to-br from-primary-500 to-primary-700 rounded-xl flex items-center justify-center shadow-medium">
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <div>
            <h1 className="text-lg font-bold text-secondary-900">KICT 시추주상도 관리 시스템</h1>
            <p className="text-xs text-secondary-500">Drill Log Analysis Tool</p>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
